export const PAGE_ID = 'TM_IAD_ALERTS_DETAILS';

export const ALERT_TOP_PANEL_DETAIL_GS_QUERY = {
  widgetGroupId: 'TM_IAD_ALERT_DETAILS_TOP_PANEL_GROUP',
  widgetId: 'TM_IAD_ALERT_BASIC_DETAILS'
};

export const TRANSACTION_DETAILS_GS_QUERY = {
  widgetGroupId: 'TRM_SMART_ASSESSMENT_TRANSACTION_DETAILS_GROUP',
  widgetId: 'TRM_SMART_ASSESSMENT_TRANSACTION_DETAILS_WIDGET'
};

export const TRANSACTION_DETAILS_WIDGET_SETTINGS = {
  uiWidgetGroups: [
    {
      widgetGroupId: 'TRM_SMART_ASSESSMENT_TRANSACTION_DETAILS_GROUP',
      widgetGroupIndex: 0,
      widgets: [
        {
          isVisible: true,
          isSingleLevel: true,
          widgetId: 'TRM_SMART_ASSESSMENT_TRANSACTION_DETAILS_WIDGET',
          widgetIndex: 0,
          widgetGroupId: 'TRM_SMART_ASSESSMENT_TRANSACTION_DETAILS_GROUP',
          widgetName: 'Transaction Details',
          widgetConfig: [
            {
              columnIndex: 0,
              columnId: 'id',
              columnName: 'Transaction ID',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 0,
                  itemLabel: 'Transaction ID',
                  itemName: 'id',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 1,
              columnId: 'transactionDate',
              columnName: 'Transaction Timestamp',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 1,
                  itemLabel: 'Transaction Timestamp',
                  itemName: 'transactionDate',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 2,
              columnId: 'accountId',
              columnName: 'Account Number',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 2,
                  itemLabel: 'Account Number',
                  itemName: 'accountId',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 3,
              columnId: 'transactionTypeCode',
              columnName: 'Transaction Type',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 3,
                  itemLabel: 'Transaction Type',
                  itemName: 'transactionTypeCode',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 4,
              columnId: 'instrument',
              columnName: 'Instrument',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 3,
                  itemLabel: 'Instrument',
                  itemName: 'instrument',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 5,
              columnId: 'localCurrencyEquivalent',
              columnName: 'Transaction Amount',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 5,
                  itemLabel: 'Transaction Amount',
                  itemName: 'localCurrencyEquivalent',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 6,
              columnId: 'sourceOfTxnFunds',
              columnName: 'Source of Funds',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 6,
                  itemLabel: 'Source of Funds',
                  itemName: 'sourceOfTxnFunds',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 7,
              columnId: 'destinationOfFunds',
              columnName: 'Destination of Funds',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 7,
                  itemLabel: 'Destination of Funds',
                  itemName: 'destinationOfFunds',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 8,
              columnId: 'beneficiarySummary',
              columnName: 'Beneficiary Details',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 8,
                  itemLabel: 'Beneficiary Details',
                  itemName: 'beneficiarySummary',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 9,
              columnId: 'transactionPurpose',
              columnName: 'Transaction Purpose',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 9,
                  itemLabel: 'Transaction Purpose',
                  itemName: 'transactionPurpose',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 10,
              columnId: 'originatorBeneficiaryName',
              columnName: 'Originator Bank Name\nBeneficiary Bank Name',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 10,
                  itemLabel: 'Originator Bank Name\nBeneficiary Bank Name',
                  itemName: 'originatorBeneficiaryName',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 11,
              columnId: 'oppAccountNumber',
              columnName: 'Opp Account Number',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 11,
                  itemLabel: 'Opp Account Number',
                  itemName: 'oppAccountNumber',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 12,
              columnId: 'transactionTypeCode',
              columnName: 'Transaction Type Code',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 12,
                  itemLabel: 'Transaction Type Code',
                  itemName: 'transactionTypeCode',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 13,
              columnId: 'atmId',
              columnName: 'ATM ID',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 13,
                  itemLabel: 'ATM ID',
                  itemName: 'atmId',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 14,
              columnId: 'tellerId',
              columnName: 'Teller ID',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 14,
                  itemLabel: 'Teller ID',
                  itemName: 'tellerId',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 15,
              columnId: 'transactionTypeDescription',
              columnName: 'Transaction Type Category',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 15,
                  itemLabel: 'Transaction Type Category',
                  itemName: 'transactionTypeDescription',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 16,
              columnId: 'bankBranchCode',
              columnName: 'Bank Branch Code',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 16,
                  itemLabel: 'Bank Branch Code',
                  itemName: 'bankBranchCode',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 17,
              columnId: 'counterParty',
              columnName: 'Counterparty ID',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 17,
                  itemLabel: 'Counterparty ID',
                  itemName: 'counterParty',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 18,
              columnId: 'counterPartyName',
              columnName: 'Counterparty Name',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 18,
                  itemLabel: 'Counterparty Name',
                  itemName: 'counterPartyName',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 19,
              columnId: 'counterpartyNationality',
              columnName: 'Counterparty Nationality',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 19,
                  itemLabel: 'Counterparty Nationality',
                  itemName: 'counterpartyNationality',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 20,
              columnId: 'counterpartyType',
              columnName: 'CounterpartyType',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 20,
                  itemLabel: 'Counterparty Type',
                  itemName: 'counterpartyType',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 21,
              columnId: 'thirdPartyRefund',
              columnName: 'Third Party Refund',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 21,
                  itemLabel: 'Third Party Refund',
                  itemName: 'thirdPartyRefund',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 22,
              columnId: 'ipRiskiness',
              columnName: 'IP Riskiness',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 22,
                  itemLabel: 'IP Riskiness',
                  itemName: 'ipRiskiness',
                  visibility: true
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export const TRANSACTION_DETAILS_WIDGET_SETTINGS_PREVENTION = {
  uiWidgetGroups: [
    {
      widgetGroupId: 'TRM_SMART_ASSESSMENT_TRANSACTION_DETAILS_GROUP',
      widgetGroupIndex: 0,
      widgets: [
        {
          isVisible: true,
          isSingleLevel: true,
          widgetId: 'TRM_SMART_ASSESSMENT_TRANSACTION_DETAILS_WIDGET',
          widgetIndex: 0,
          widgetGroupId: 'TRM_SMART_ASSESSMENT_TRANSACTION_DETAILS_GROUP',
          widgetName: 'Transaction Details',
          widgetConfig: [
            {
              columnIndex: 0,
              columnId: 'id',
              columnName: 'Transaction ID',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 0,
                  itemLabel: 'Transaction ID',
                  itemName: 'id',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 1,
              columnId: 'transactionDate',
              columnName: 'Transaction Timestamp',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 1,
                  itemLabel: 'Transaction Timestamp',
                  itemName: 'transactionDate',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 2,
              columnId: 'accountId',
              columnName: 'Account Number',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 2,
                  itemLabel: 'Account Number',
                  itemName: 'accountId',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 3,
              columnId: 'transactionTypeCode',
              columnName: 'Transaction Type',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 3,
                  itemLabel: 'Transaction Type',
                  itemName: 'transactionTypeCode',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 4,
              columnId: 'transactionCurrencyAmount',
              columnName: 'Sender Amount',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 4,
                  itemLabel: 'Sender Amount',
                  itemName: 'transactionCurrencyAmount',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 5,
              columnId: 'localCurrencyEquivalent',
              columnName: 'Receiver Amount',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 5,
                  itemLabel: 'Receiver Amount',
                  itemName: 'localCurrencyEquivalent',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 6,
              columnId: 'instrument',
              columnName: 'Credit Party',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 6,
                  itemLabel: 'Credit Party',
                  itemName: 'instrument',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 7,
              columnId: 'sourceOfTxnFunds',
              columnName: 'Source of Funds',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 7,
                  itemLabel: 'Source of Funds',
                  itemName: 'sourceOfTxnFunds',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 8,
              columnId: 'destinationOfFunds',
              columnName: 'Destination of Funds',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 8,
                  itemLabel: 'Destination of Funds',
                  itemName: 'destinationOfFunds',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 9,
              columnId: 'beneficiarySummary',
              columnName: 'Beneficiary Details',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 9,
                  itemLabel: 'Beneficiary Details',
                  itemName: 'beneficiarySummary',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 10,
              columnId: 'transactionPurpose',
              columnName: 'Transaction Purpose',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 10,
                  itemLabel: 'Transaction Purpose',
                  itemName: 'transactionPurpose',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 11,
              columnId: 'originatorBeneficiaryName',
              columnName: 'Originator Bank Name\nBeneficiary Bank Name',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 11,
                  itemLabel: 'Originator Bank Name\nBeneficiary Bank Name',
                  itemName: 'originatorBeneficiaryName',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 12,
              columnId: 'oppAccountNumber',
              columnName: 'Opp Account Number',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 12,
                  itemLabel: 'Opp Account Number',
                  itemName: 'oppAccountNumber',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 13,
              columnId: 'transactionTypeCode',
              columnName: 'Transaction Type Code',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 13,
                  itemLabel: 'Transaction Type Code',
                  itemName: 'transactionTypeCode',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 14,
              columnId: 'atmId',
              columnName: 'Receiver Payer Service',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 14,
                  itemLabel: 'Receiver Payer Service',
                  itemName: 'atmId',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 15,
              columnId: 'tellerId',
              columnName: 'Receiver Payer Name',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 15,
                  itemLabel: 'Receiver Payer Name',
                  itemName: 'tellerId',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 16,
              columnId: 'transactionTypeDescription',
              columnName: 'Sending Partner Code',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 16,
                  itemLabel: 'Sending Partner Code',
                  itemName: 'transactionTypeDescription',
                  visibility: true
                }
              ]
            },
            {
              columnIndex: 17,
              columnId: 'bankBranchCode',
              columnName: 'Receiving Partner Code',
              columnVisibility: true,
              isDefault: true,
              columnDetail: [
                {
                  itemIndex: 17,
                  itemLabel: 'Receiving Partner Code',
                  itemName: 'bankBranchCode',
                  visibility: true
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export const LANDING_FROM = 'ALERT INVESTIGATION';
export const RETURN_TO_PATH = '/app/trm/run-instance?tab=2';
export const LANDED_IN = 'Alert Analysis';

export const SMARTASSESSMENT_TRANSACTION_DETAIL_DOWNLOAD = [
  {
    label: 'Transaction ID',
    name: 'Transaction_ID',
    key: 'id'
  },
  {
    label: 'Transaction Date',
    name: 'Transaction_Date',
    key: 'transactionDate'
  },
  {
    label: 'Account Number',
    name: 'Account_Number',
    key: 'accountId'
  },
  {
    label: 'Transaction Type',
    name: 'Transaction_Type',
    key: 'transactionTypeCode'
  },
  {
    label: 'Instrument',
    name: 'Instrument',
    key: 'instrument'
  },
  {
    label: 'Transaction Amount',
    name: 'Transaction_Amount',
    key: 'localCurrencyEquivalent'
  },
  {
    label: 'Source of Funds',
    name: 'Source_of_funds',
    key: 'sourceOfTxnFunds'
  },
  {
    label: 'Destination of Funds',
    name: 'Destination_of_funds',
    key: 'destinationOfFunds'
  },
  {
    label: 'Beneficiary Name',
    name: 'Beneficiary_Name',
    key: 'beneficiary'
  },
  {
    label: 'Beneficiary Customer Type',
    name: 'Beneficiary_Customer_Type',
    key: 'beneficiaryCustomerType'
  },
  {
    label: 'Beneficiary Bank Country Code',
    name: 'Beneficiary_Bank_Country_Code',
    key: 'beneficiaryBankCountryCode'
  },
  {
    label: 'Beneficiary C2C Linkage Present',
    name: 'Beneficiary_C2C_Linkage_Present',
    key: 'beneficiaryC2cLinkagePresent'
  },
  {
    label: 'Beneficiary Adverse News',
    name: 'Beneficiary_Adverse_News',
    key: 'beneficiaryAdverseNews'
  },
  {
    label: 'Transaction Purpose',
    name: 'transaction_Purpose',
    key: 'transactionPurpose'
  },
  {
    label: 'Originator Bank Name\nBeneficiary Bank Name',
    name: 'originator_Beneficiary_Name',
    key: 'originatorBeneficiaryName'
  },
  {
    label: 'Opp Account Number',
    name: 'oppAccount_Number',
    key: 'oppAccountNumber'
  },
  {
    label: 'Transaction Type Code',
    name: 'transaction_Type_Code',
    key: 'transactionTypeCode'
  },
  {
    label: 'ATM ID',
    name: 'atm_Id',
    key: 'atmId'
  },
  {
    label: 'Teller ID',
    name: 'teller_Id',
    key: 'tellerId'
  },
  {
    label: 'Transaction Type Category',
    name: 'transaction_Type_Description',
    key: 'transactionTypeDescription'
  },
  {
    label: 'Bank Branch Code',
    name: 'bank_Branch_Code',
    key: 'bankBranchCode'
  },
  {
    label: 'Counterparty Nationality',
    name: 'counterparty_Nationality',
    key: 'counterpartyNationality'
  },
  {
    label: 'Counterparty Type',
    name: 'counterparty_Type',
    key: 'counterpartyType'
  },
  {
    label: 'Third Party Refund',
    name: 'third_Party_Refund',
    key: 'thirdPartyRefund'
  },
  {
    label: 'IP Riskiness',
    name: 'ip_Riskiness',
    key: 'ipRiskiness'
  }
];

export const SMARTASSESSMENT_TRANSACTION_DETAIL_PREVENTION_DOWNLOAD = [
  {
    label: 'Transaction ID',
    name: 'Transaction_ID',
    key: 'id'
  },
  {
    label: 'Transaction Date',
    name: 'Transaction_Date',
    key: 'transactionDate'
  },
  {
    label: 'Account Number',
    name: 'Account_Number',
    key: 'accountId'
  },
  {
    label: 'Transaction Type',
    name: 'Transaction_Type',
    key: 'transactionTypeCode'
  },
  {
    label: 'Sender Amount',
    name: 'Sender_Amount',
    key: 'transactionCurrencyAmount'
  },
  {
    label: 'Receiver Amount',
    name: 'Receiver_Amount',
    key: 'localCurrencyEquivalent'
  },
  {
    label: 'Credit Party',
    name: 'Credit Party',
    key: 'instrument'
  },
  {
    label: 'Source of Funds',
    name: 'Source_of_funds',
    key: 'sourceOfTxnFunds'
  },
  {
    label: 'Destination of Funds',
    name: 'Destination_of_funds',
    key: 'destinationOfFunds'
  },
  {
    label: 'Beneficiary Name',
    name: 'Beneficiary_Name',
    key: 'beneficiary'
  },
  {
    label: 'Beneficiary Customer Type',
    name: 'Beneficiary_Customer_Type',
    key: 'beneficiaryCustomerType'
  },
  {
    label: 'Beneficiary Bank Country Code',
    name: 'Beneficiary_Bank_Country_Code',
    key: 'beneficiaryBankCountryCode'
  },
  {
    label: 'Beneficiary C2C Linkage Present',
    name: 'Beneficiary_C2C_Linkage_Present',
    key: 'beneficiaryC2cLinkagePresent'
  },
  {
    label: 'Beneficiary Adverse News',
    name: 'Beneficiary_Adverse_News',
    key: 'beneficiaryAdverseNews'
  },
  {
    label: 'Transaction Purpose',
    name: 'transaction_Purpose',
    key: 'transactionPurpose'
  },
  {
    label: 'Originator Bank Name\nBeneficiary Bank Name',
    name: 'originator_Beneficiary_Name',
    key: 'originatorBeneficiaryName'
  },
  {
    label: 'Opp Account Number',
    name: 'oppAccount_Number',
    key: 'oppAccountNumber'
  },
  {
    label: 'Transaction Type Code',
    name: 'transaction_Type_Code',
    key: 'transactionTypeCode'
  },
  {
    label: 'Receiver Payer Service',
    name: 'atm_Id',
    key: 'atmId'
  },
  {
    label: 'Receiver Payer Name',
    name: 'teller_Id',
    key: 'tellerId'
  },
  {
    label: 'Sending Partner Code',
    name: 'transaction_Type_Description',
    key: 'transactionTypeDescription'
  },
  {
    label: 'Receiving Partner Code',
    name: 'bank_Branch_Code',
    key: 'bankBranchCode'
  }
];
